// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__36xVH","productName":"Table_productName__-nVm7"};